import { ApiConstants } from ".";

export const caseSummaryType:any = {
    1: "ChildrensSocialCare",
    2: "SingleViewOfDebt"
}


export const MSAL_CONFIG: any = {
    auth: {
        clientId: ApiConstants.MSAL_CLIENT_ID,
        redirectUri: ApiConstants.MSAL_REDIRECT_URL,
    }
};

export const MSAL_LOGINREQUEST: any = {
    scopes: [ApiConstants.MSAL_SCOPE],
};

